import React, { useState } from "react";
import {Link} from 'react-router-dom';
import {MAIL_ACCOUNT_ALL_LINK} from '../../constants/constants';
import FormValidator from "../../FormValidator";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import client from "../../api";
import { notifyError, notifySuccess } from "../../helper";

const CreateMailAccounts = () =>{
    const api = client();
    const [data, setData] = useState({
        email:'',
        fullname:'',
        smtphostname:'',
        smtpportnumber:'',
        smtpusername:'',
        smtppassword:'',
        imaphostname:'',
        imapportnumber:'',
        imapusername:'',
        imappassword:''
    });
    const [loading,setLoading] = useState(false);
    const validatorRules = {
        email: {
            rule1:{
                message: "Please Enter a valid Email Address.",
                validator: (val) => !(/\S+@\S+\.\S+/.test(val))
            }
        },
        fullname: {
            empty:"Please Enter Full Name"
        },
        smtphostname:{
            rule1:{
                message: "Please Enter a Valid SMTP Host Name.",
                validator: (val) => !((/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/).test(val))
            }
        },
        smtpportnumber:{
            empty:"Please Enter SMTP Port Number."
        },
        smtpusername:{
            empty:"Please Enter SMTP Username."
        },
        smtppassword:{
            empty:"Please Enter SMTP Password."
        },
        imaphostname:{
            rule1:{
                message: "Please Enter a Valid IMAP Host Name.",
                validator: (val) => !((/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/).test(val))
            }
        },
        imapportnumber:{
            empty:"Please Enter IMAP Port Number."
        },
        imapusername:{
            empty:"Please Enter IMAP Username."
        },
        imappassword:{
            empty:"Please Enter IMAP Password."
        }
    }

    const prepareData = (input) => {
        setData({...data,...input});    
    }

    //For error validations
    const validatorObject = new FormValidator(validatorRules);
    const [error, setError] = useState({});

    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }

    const fieldBlur = e => {
        const fieldError = validatorObject.validateFields(e.target.value, e.target.name)
        if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }

    const fieldFocus = e => {
        removeError(e);
        //update()
    }
    
    const validateAllFields = (inputs) => {
        const v = validatorObject.validateFields(inputs);
        if(Object.keys(v).length === 0){
            return true;
        } else {
            setError({...v});
            return false;
        }       
    }
    const rearrangeData = (inputValues) => {
        return {
            "name": inputValues.fullname,
            "email": inputValues.email,
            "smtp": {
                "server": inputValues.smtphostname,
                "port": inputValues.smtpportnumber,
                "username": inputValues.smtpusername,
                "password": inputValues.smtppassword
            },
            "imap": {
                "server": inputValues.imaphostname,
                "port": inputValues.imapportnumber,
                "username": inputValues.imapusername,
                "password": inputValues.imappassword
            }
        }
    }
    const createSmtpAccount = async () => {
        setLoading(true);
        try{
            if(validateAllFields(data)){
                const finalData = rearrangeData(data);
                const response = await api.post('/v1/mailAccount/create/smtp',{
                ...finalData
                });
                if(response.status === 200 || response.status === 201){
                    notifySuccess('SMTP account created');
                    setLoading(false);
                    setTimeout(()=>{
                        window.location.href = MAIL_ACCOUNT_ALL_LINK;
                    },1500);
                }
            } else{
                setLoading(false);
            }
            
        
        } catch(error){
            setLoading(false);
            if(error.status === 409) notifyError('This mail account already exists. Please add a different mail account.');
            if(error.status === 400) notifyError('Bad Request. Not able to create a mail account. Please try again');
        }
    }

    return(<>
     <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="mailaccounts-pages-wrap">
               <div className="top-section">
                    <h1>Mail Connection </h1>
                    <div className="button-group">
                        <Link to={MAIL_ACCOUNT_ALL_LINK} className="primary-btn"><i className="bx bx-list-ul"></i> All  Mail Accounts</Link>
                    </div>
               </div>
               <div className="create-mailaccount-wrap">
                    <div className="mail-create-form">
                        <form onSubmit={(e)=>{e.preventDefault();}} encType="multipart/form-data" method="post">
                            <div className="head">
                                <h2>Add SMTP Mail Connection</h2>
                            </div>
                            <div className="form-content">
                                <h3>Sending address</h3>
                                <p>This will be the "From" name and address on your emails and must be an address allowed by your email provider.</p>
                            </div>
                            <div className="form-group">
                                <div className="field-wrap">
                                    <label className="label-xs">Email address</label>
                                    <input 
                                        type="email" 
                                        name="email" 
                                        placeholder="Email Address"
                                        value={data?.email ? data.email:''}
                                        onChange={(e)=>{
                                            prepareData({"email": e.target.value});
                                        }}
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.email && <span className="validation-error">{error.email}</span>}
                                </div>
                                <div className="field-wrap">
                                    <label className="label-xs">Full Name</label>
                                    <input 
                                        type="text" 
                                        name="fullname" 
                                        placeholder="Full Name"
                                        value={data?.fullname ? data.fullname:''}
                                        onChange={(e)=>{
                                            prepareData({"fullname": e.target.value});
                                        }} 
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.fullname && <span className="validation-error">{error.fullname}</span>}
                                </div>
                            </div>
                            <div className="form-content">
                                <h3>SMTP connection</h3>
                                <p>This information comes from your email provider and is how we'll send your emails.</p>
                            </div>
                            <div className="form-group">
                                <div className="column-2-inner">
                                    <div className="field-wrap col-1">
                                        <label className="label-xs">Host (e.g. mail.server.com)</label>
                                        <input 
                                            type="text" 
                                            name="smtphostname" 
                                            placeholder="Host Name" 
                                            value={data?.smtphostname ? data.smtphostname:''}
                                            onChange={(e)=>{
                                                prepareData({"smtphostname": e.target.value});
                                            }} 
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}
                                            onFocus={(e) =>{
                                                fieldFocus(e)
                                            }}
                                            />
                                            {error.smtphostname && <span className="validation-error">{error.smtphostname}</span>}
                                    </div>
                                    <div className="field-wrap col-2">
                                        <label className="label-xs">Port number</label>
                                        <select
                                            name="smtpportnumber" 
                                            className="selectbox" 
                                            onChange={(e)=>{
                                                prepareData({'smtpportnumber':e.target.value});
                                            }}
                                            onFocus={(e)=>{
                                                fieldFocus(e);
                                            }}
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}
                                            >
                                                <option value={''}>Port</option>
                                                <option value={25}>25</option>
                                                <option value={465}>465</option>
                                                <option value={587}>587</option>
                                                <option value={2525}>2525</option>
                                        </select>
                                        {error.smtpportnumber && <span className="validation-error">{error.smtpportnumber}</span>}                                
                                    </div>
                                </div>
                            
                                <div className="field-wrap">
                                    <label className="label-xs">Username (usually your email address)</label>
                                    <input 
                                        type="text" 
                                        name="smtpusername" 
                                        placeholder="Username"
                                        value={data?.smtpusername ? data.smtpusername:''}
                                        onChange={(e)=>{
                                            prepareData({"smtpusername": e.target.value});
                                        }} 
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.smtpusername && <span className="validation-error">{error.smtpusername}</span>}
                                </div>

                                <div className="field-wrap">
                                    <label className="label-xs">Password</label>
                                    <input 
                                        type="password" 
                                        name="smtppassword" 
                                        placeholder="*****"
                                        value={data?.smtppassword ? data.smtppassword:''}
                                        onChange={(e)=>{
                                            prepareData({"smtppassword": e.target.value});
                                        }}  
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.smtppassword && <span className="validation-error">{error.smtppassword}</span>}
                                </div>
                            </div>
                            <div className="form-content">
                                <h3>IMAP connection</h3>
                                <p>This information comes from your email provider and is how we'll check your inbox for replies.</p>
                            </div>
                            <div className="form-group">
                                <div className="column-2-inner">
                                    <div className="field-wrap col-1">
                                        <label className="label-xs">Host (e.g. mail.server.com)</label>
                                        <input 
                                            type="text" 
                                            name="imaphostname" 
                                            placeholder="Host Name"
                                            value={data?.imaphostname ? data.imaphostname:''}
                                            onChange={(e)=>{
                                                prepareData({"imaphostname": e.target.value});
                                            }} 
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}
                                            onFocus={(e) =>{
                                                fieldFocus(e)
                                            }}
                                            />
                                            {error.imaphostname && <span className="validation-error">{error.imaphostname}</span>}
                                        </div>
                                        <div className="field-wrap col-2">
                                        <label className="label-xs">Port number</label>
                                        <select 
                                            name="imapportnumber"
                                            className="selectbox"
                                            onChange={(e)=>{
                                                prepareData({'imapportnumber':e.target.value});
                                            }}
                                            onFocus={(e)=>{
                                                fieldFocus(e);
                                            }}
                                            onBlur={(e)=>{
                                                fieldBlur(e);
                                            }}>
                                                <option value={''}>Port</option>
                                                <option value={143}>143</option>
                                                <option value={993}>993</option>
                                                <option value={995}>995</option>
                                        </select>
                                        {error.imapportnumber && <span className="validation-error">{error.imapportnumber}</span>}
                                    </div>
                                </div>
                                <div className="field-wrap">
                                    <label className="label-xs">Username (usually your email address)</label>
                                    <input 
                                        type="text" 
                                        name="imapusername" 
                                        placeholder="Username" 
                                        value={data?.imapusername ? data.imapusername:''}
                                        onChange={(e)=>{
                                            prepareData({"imapusername": e.target.value});
                                        }}
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.imapusername && <span className="validation-error">{error.imapusername}</span>}
                                </div>

                                <div className="field-wrap">
                                    <label className="label-xs">Password</label>
                                    <input 
                                        type="password" 
                                        name="imappassword" 
                                        placeholder="*****"
                                        value={data?.imappassword ? data.imappassword:''}
                                        onChange={(e)=>{
                                            prepareData({"imappassword": e.target.value});
                                        }} 
                                        onBlur={(e)=>{
                                            fieldBlur(e);
                                        }}
                                        onFocus={(e) =>{
                                            fieldFocus(e)
                                        }}
                                        />
                                        {error.imappassword && <span className="validation-error">{error.imappassword}</span>}
                                </div>
                            </div>
                            <div className="field-wrap form-btn">
                                <button 
                                className={loading ? "primary-btn button--loading":"primary-btn"} 
                                disabled={loading}
                                onClick={()=>{
                                    createSmtpAccount()
                                }}><span className="button--text">Save</span></button>
                                <button className="back-btn" onClick={()=>{
                                    window.location.href= MAIL_ACCOUNT_ALL_LINK;
                                }}>Back</button>
                            </div>

                        </form>
                    </div>

               </div>
                
                

            </div>
        </div>
        <Footer/>
    </>);
}

export default CreateMailAccounts;